import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum FileImportFormErrorStatesEnum {
    ConvertFileFailed = ErrorStateScheduleEnum.FileImportFormErrorStatesStartIndex,
    FileValidationFailed,
    FileValidationErrorsOccurred,
    FileImportFailed
}
